/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { FaUserTie, FaWhatsappSquare } from "react-icons/fa";
import { TipoFormulario, ESTADOS_BRASIL } from "../../../../services/constantes";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { ApiError, Campo, PrestadorServico } from "../../../../services/tipos";
import { obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { useFiliais } from "../../../../hooks/useFiliais";

function PrestadorDeServicoListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [estado, setEstado] = useState<string>('');
    const [estados, setEstados] = useState<any[]>([]);
    const [cidades, setCidades] = useState<any[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [mascaraDocumento, setMascaraDocumento] = useState<string>('');
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [prestadorServicos, setLocatarios] = useState<PrestadorServico[]>([]);
    const [carregandoSelectCidades, setCarregandoSelectCidades] = useState<boolean>(false);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [prestadorServicoSelecionado, setPrestadorDeServicoSelecionado] = useState<PrestadorServico>({} as PrestadorServico);

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { field: 'documento', headerName: 'Documento', flex: 1 },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ]

    const campoFilial = getCampoFilial({ linha: 2, coluna: 1, largura: 12 });

    const campos: Campo[] = [
        { label: 'Identificação:', nome: '', required: false, tipo: 'label', largura: 3, coluna: 1, linha: 1, visible: true, },
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 2, visible: true, tudoMaiusculo: true },
        {
            label: 'Tipo Documento', nome: 'tipoDocumento', required: true, tipo: 'select', largura: 4, coluna: 1, linha: 3, visible: true, opcoes: [{ label: 'CPF', valor: 1 }, { label: 'CNPJ', valor: 2 }], onCampoDigitar(e) {
                if (e == 1) {
                    setMascaraDocumento('999.999.999-99');
                } else {
                    setMascaraDocumento('99.999.999/9999-99');
                }
            },
        },
        { label: 'Documento', nome: 'documento', required: true, tipo: 'text', largura: 4, coluna: 2, linha: 3, visible: true, mascara: mascaraDocumento },
        { label: 'Telefone', nome: 'telefone', required: true, tipo: 'text', largura: 4, coluna: 3, linha: 3, visible: true, mascara: '(99) 99999-9999' },
        { label: 'Endereço:', nome: '', required: false, tipo: 'label', largura: 6, coluna: 2, linha: 4, visible: true, },
        {
            label: 'CEP', nome: 'cep', required: true, tipo: 'text', largura: 4, coluna: 1, linha: 5, visible: true, mascara: '99999-999', onCampoSair(e) {
                let cep = e.replace(/\D/g, '');
                if (cep.length == 8) {
                    buscarPorCep(e);
                }
            },
        },
        {
            label: 'Estado', nome: 'estado', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 5, visible: true, opcoes: estados, onCampoSair(e) {
                setEstado(e);
            }, allowNotFoundValues: true
        },
        { label: 'Cidade', nome: 'cidade', required: true, tipo: 'select', largura: 4, coluna: 3, linha: 5, visible: true, opcoes: cidades, carregando: carregandoSelectCidades, allowNotFoundValues: true },
        { label: 'Logradouro', nome: 'logradouro', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 6, visible: true, },
        { label: 'Numero', nome: 'numero', required: true, tipo: 'text', largura: 6, coluna: 2, linha: 6, visible: true, },
        { label: 'Bairro', nome: 'bairro', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 7, visible: true, },
        { label: 'Complemento', nome: 'complemento', required: false, tipo: 'text', largura: 6, coluna: 2, linha: 7, visible: true, },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 8, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemPermissao(token, 'prestadorservico_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        if(error.message.includes("404")) {
            setCarregando(false);
            setCarregandoSelectCidades(false);
            return;
        }
        setCarregando(false);
        toast.error('Não foi possível continuar a operação Prestador / Fornecedor: ' + error.response?.data.Mensagem)
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'prestadorservico_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setPrestadorDeServicoSelecionado({} as PrestadorServico);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo Prestador / Fornecedor');
        }
    }

    const handleEditar = (PrestadorServico: any) => {
        if (usuarioTemPermissao(token, 'prestadorservico_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setPrestadorDeServicoSelecionado(PrestadorServico);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um Prestador / Fornecedor');
        }
    }

    const handleExclusao = async (PrestadorServico: PrestadorServico) => {
        if (usuarioTemPermissao(token, 'prestadorservico_excluir')) {
            setCarregando(true);
            await api.delete(`/PrestadorServico/${PrestadorServico.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Prestador / Fornecedor foi excluído com sucesso')
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = (PrestadorServico: any) => {
        if (usuarioTemPermissao(token, 'prestadorservico_visualizar')) {
            setPrestadorDeServicoSelecionado(PrestadorServico);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    useEffect(() => {
        const fetchPrestadorDeServicoPorEmpresa = async() => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`/prestadorServicosPorEmpresa/${obterIdTenent(token)}`)
                    .then(response => {
                        setTimeout(() => {
                            setLocatarios(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error);
                    });
            }
        }

        fetchPrestadorDeServicoPorEmpresa();
    }, [temPermissao, realizarConsulta, token]);

    const buscarPorCep = async (cep: string) => {
        try {
            const apiGenerica = axios.create({ baseURL: 'https://viacep.com.br/ws/' });
            cep = cep.replace(/\D/g, '');
            let endPoint = `${cep}/json/`;

            const response = await apiGenerica.get(endPoint);
            const infoCep = response.data;
            const camposAtualizados = {
                logradouro: infoCep.logradouro,
                bairro: infoCep.bairro,
                cidade: infoCep.localidade,
                estado: infoCep.uf,
            };

            setEntidadeParaAtualizarNoModal(camposAtualizados);
            await buscarCidades(camposAtualizados.estado);
            setForcarAtualizacaoDeEntidadeNoModal(true);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const buscarCidades = async (codigoEstado: string) => {
        if (codigoEstado) {
            setCarregandoSelectCidades(true);

            const apiGenerica = axios.create({ baseURL: 'https://brasilapi.com.br/api/' });
            let endPoint = `ibge/municipios/v1/${codigoEstado}`;

            apiGenerica.get(endPoint).then((response) => {
                const novasOpcoes = response.data.map((cidade: any) => ({
                    codigo: cidade.nome,
                    valor: cidade.nome,
                    label: cidade.nome,
                }));

                setCidades(novasOpcoes);
                setCarregandoSelectCidades(false);
            }).catch(tratarErro);
        }
    }

    const handleShowModal = async () => {
        setEstados([]);
        setCidades([]);

        setCarregando(true);

        const novasOpcoes = ESTADOS_BRASIL.map((uf) => ({
            codigo: uf.sigla,
            valor: uf.sigla,
            label: uf.nome,
        }));

        setEstados(novasOpcoes);
        setCarregando(false);

        if (modo !== TipoFormulario.tpEdicao && modo !== TipoFormulario.tpVisualizacao) return;

        setCarregando(true);

        const apiGenerica = axios.create({ baseURL: 'https://brasilapi.com.br/api/' });
        let endPointCidades = `ibge/municipios/v1/${prestadorServicoSelecionado.estado}`;

        await apiGenerica.get(endPointCidades).then((response) => {
            const novasOpcoes = response.data.map((cidade: any) => ({
                codigo: cidade.nome,
                valor: cidade.nome,
                label: cidade.nome,
            }));

            setCidades(novasOpcoes);
            setCarregando(false);
        }).catch(tratarErro);

        if (prestadorServicoSelecionado) {
            let tipoDocumento = prestadorServicoSelecionado.tipoDocumento;

            if (tipoDocumento == 1) {
                setMascaraDocumento('999.999.999-99');
            } else {
                setMascaraDocumento('99.999.999/9999-99');
            }
        }
    }
    
    useEffect(() => {
        const fetchBuscarCidades = async (estado: any) => {
            if (prestadorServicoSelecionado) {
                if (estado) {
                    if (modo != TipoFormulario.tpNenhum) {
                        await buscarCidades(estado);
                    }
                }
            }
        }

        fetchBuscarCidades(estado);
    }, [estado, modo, prestadorServicoSelecionado]);

    const chamarWhatsapp = async (numero: string) => {
        numero = numero.replace(/\D/g, '');
        let url = `https://wa.me/+55${numero}`
        window.open(url, '_blank');
    };

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Prestador / Fornecedor salvo com sucesso');
        setFezAlgumaAcao(true);
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('prestadorservico')}
                    colunas={colunas}
                    linhas={prestadorServicos}
                    nomeEntidade="Prestadores / Fornecedores"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaUserTie}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setPrestadorDeServicoSelecionado}
                    acoesExtras={
                        [{
                            Icone: FaWhatsappSquare, OnClick: (entidade) => {
                                chamarWhatsapp(entidade.telefone)
                            }, Texto: 'WhatsApp', Cor: 'green'
                        }]}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('PrestadorServico', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('PrestadorServico', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onShow={handleShowModal}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Aqui você pode cadastrar Prestadores de Serviço e Fornecedores que serão utilizados em movimentações, como serviços relacionados a veículos. Essa funcionalidade é útil para consultas futuras e para um melhor controle das Manutenções por cada prestador ou fornecedor.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={prestadorServicoSelecionado}
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                    apiConfig={
                        {
                            endpoint: "PrestadorServico",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default PrestadorDeServicoListagem;